













import { Component, Mixins, Prop } from "vue-property-decorator";
import { Patient } from "../../../../../domain/patient";
import { ModelEditableMixin } from "../../../../system/mixins";
import { PatientFindView } from "../../../../patient/selectors/wizard/guest";
import { SimplePatientViewer } from "../../../../patient/viewers/wizard/guest";
import { SpecifiedPatientViewMixin } from "../../../../patient/mixins";
import { DocumentListViewer } from "./";

@Component({
  components: {
    DocumentListViewer,
    PatientFindView,
    SimplePatientViewer,
  }
})
export default class PatientDocumentListViewer extends Mixins(ModelEditableMixin, SpecifiedPatientViewMixin) {
  @Prop()
  shouldAuthenticateLater: boolean;

  onPatientChanged(selected: Patient): void {
    this.patient = selected;
  }
}
